import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { LOGO_CRESCENT } from "@/components/landing/data";

export default function PaymentCancel() {
  return (
    <main data-testid="payment-cancel-page" className="bg-[#ffffff] text-[#0a0a0b] min-h-screen flex items-center justify-center px-5 relative overflow-hidden">
      <div className="absolute inset-0 hero-radial" />
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="relative z-10 w-full max-w-md bg-[#faf9f6] border border-[#e3e2dc] rounded-3xl p-10 text-center"
      >
        <img src={LOGO_CRESCENT} alt="Deen District" className="h-12 w-12 mx-auto mb-6" />
        <p className="font-mono-d text-[10px] uppercase tracking-[0.25em] text-[#ff2a85]">Checkout cancelled</p>
        <h1 className="font-display font-extrabold uppercase text-3xl mt-3 leading-none">No charge was made</h1>
        <p className="text-[#5f5e5a] text-sm mt-3 leading-relaxed">
          Your piece is still waiting. Drop 001 is extremely limited — come back when you're ready.
        </p>
        <Link data-testid="back-to-lookbook-link" to="/" className="mt-8 inline-block px-8 py-4 rounded-full bg-[#ff2a85] text-white font-mono-d text-[11px] uppercase tracking-[0.2em] hover:bg-[#e60067] transition-colors">
          Back to the Lookbook
        </Link>
      </motion.div>
    </main>
  );
}
